import clientMiddleware from './middleware/client';
import thunkMiddleware from './middleware/thunk';

export default [clientMiddleware, thunkMiddleware];
